import axiosInstance from "./AxiosConfig";

class NotificationPopupApi {
  async create(payload) {
    try {
      const response = await axiosInstance.post("/notificationPopup/create", payload);
      return response.data;
    } catch (error) {
      console.error(error);
      return error?.response?.data || null;
    }
  }

  async getAll() {
    try {
      const response = await axiosInstance.get("/notificationPopup/getAll");
      return response.data;
    } catch (error) {
      console.error(error);
      return error?.response?.data || null;
    }
  }

  async DeleteNotification(id) {
    try {
      const response = await axiosInstance.delete(`/notificationPopup/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateNotification(id, payload) {
    try {
      const response = await axiosInstance.put(`/notificationPopup/update/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error(error);
      return error?.response?.data || null;
    }
  }

}

export default new NotificationPopupApi();
